import EfFooterTc from '@elem/ui/ef-footer-tc';
import { useRouter } from 'next/router';
import { termsMap } from '@elem/compPage/next-level-power/config/terms';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import EfSpec from '@elem/ui/ef-spec';

export default function TheComp() {
    const { locale = 'us' } = useRouter();
    const { t } = useLang('rapid.FootTC');
    const termsData = termsMap[locale as keyof typeof termsMap] || termsMap.eu;

    const listA = [
        {
            isHeader: true,
            title: t('title1'),
        },
        {
            title: t('item_a1'),
        },
        {
            title: t('item_a2'),
        },
        {
            title: t('item_a3'),
        },
        {
            title: t('item_a4'),
        },
    ];
    const listB = [
        {
            isHeader: true,
            title: t('title2'),
        },
        {
            title: t('item_b1'),
        },
        {
            title: t('item_b2'),
        },
        {
            title: t('item_b3'),
        },
        {
            title: t('item_b4'),
        },
        {
            title: t('item_b5'),
        },
        {
            isHeader: true,
            title: t('title1'),
        },
        {
            title: t('item_a1'),
        },
        {
            title: t('item_a2'),
        },
        {
            title: t('item_a3'),
        },
        {
            title: t('item_a4'),
        },
    ];
    return (
        <div className={css.TheComp}>
            <EfFooterTc list={['jp'].includes(locale) ? listA : listB} />
            {!['us', 'ca', 'jp', 'mx', 'kr', 'ph'].includes(locale) && <EfFooterTc list={termsData} />}
            <EfSpec />
        </div>
    );
}
